import { render, staticRenderFns } from "./PreviewPriceList.vue?vue&type=template&id=b537f99a&"
import script from "./PreviewPriceList.vue?vue&type=script&lang=js&"
export * from "./PreviewPriceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports